import { useCallback, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL, authFetch } from "../utils/auth";
import ToolSidebar from "../utils/ToolSideBar";
import OfferCard from "./OfferCard";
import "../../css/offers/OfferWorkspace.css";

function invoicePathFromResponse(data) {
  const target = data?.invoice_url || data?.url || (data?.invoice_id ? `/invoices/${data.invoice_id}` : "");
  if (!target) return "";
  try {
    const parsed = new URL(target, window.location.origin);
    return parsed.origin === window.location.origin && parsed.pathname.startsWith("/invoices/") ? parsed.pathname + parsed.search + parsed.hash : "";
  } catch (_err) {
    return target.startsWith("/invoices/") ? target : "";
  }
}
export default function OfferDetailPage() {
  const { offerId } = useParams();
  const navigate = useNavigate();
  const [offer, setOffer] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  const [paying, setPaying] = useState(false);

  const loadOffer = useCallback(async () => {
    setLoading(true);
    const response = await authFetch(`${API_URL}/offers/${offerId}/`);
    const data = await response.json();
    if (!response.ok) setError(data.detail || "Unable to load offer.");
    else setOffer(data);
    setLoading(false);
  }, [offerId]);

  useEffect(() => { loadOffer(); }, [loadOffer]);

  async function pay() {
    setPaying(true);
    const response = await authFetch(`${API_URL}/offers/${offerId}/checkout/`, { method: "POST" });
    const data = await response.json();
    if (!response.ok) {
      setError(data.detail || "Unable to start checkout.");
      setPaying(false);
      return;
    }
    const invoicePath = invoicePathFromResponse(data);
    if (!invoicePath) {
      setError("Invoice unavailable.");
      setPaying(false);
      return;
    }
    navigate(invoicePath);
  }

  async function decline() {
    const response = await authFetch(`${API_URL}/offers/${offerId}/decline/`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ note: "Declined from portal." }) });
    const data = await response.json();
    if (!response.ok) setError(data.detail || "Unable to decline offer.");
    else setOffer(data);
  }

  return (
    <div className="staff-shell">
      <ToolSidebar active="inbox" />
      <main className="staff-page offer-detail-page">
        <Link to={offer?.conversation_id ? `/messages/${offer.conversation_id}` : "/inbox"} className="message-back">Back to conversation</Link>
        {loading ? <section className="staff-card"><p>Loading offer...</p></section> : error ? <section className="staff-card"><p>{error}</p></section> : offer && (
          <>
            <header className="message-detail-header">
              <span>SCD Project Offer</span>
              <h1>Offer v{offer.revision_number}</h1>
              <p>Review your project scope, timeline, and payment total.</p>
            </header>
            <OfferCard offer={offer} onPay={pay} onDecline={decline} showClientOfferAction={false} />
            <section className="staff-card offer-detail-lines">
              <h2>Scope</h2>
              {(offer.items || []).map((item) => (
                <div className="offer-line-row" key={item.id}>
                  <div><strong>{item.name}</strong><p>{item.description}</p></div>
                  <span>{item.is_included ? "Included" : `$${Number(item.line_total || 0).toFixed(2)}`}</span>
                </div>
              ))}
              {offer.client_facing_notes && <div className="offer-notes"><h3>Notes</h3><p>{offer.client_facing_notes}</p></div>}
              {offer.terms && <div className="offer-notes"><h3>Terms</h3><p>{offer.terms}</p></div>}
              {offer.can_pay && <button className="offer-pay-button" onClick={pay} disabled={paying}>{paying ? "Opening Invoice..." : "Accept and Pay"}</button>}
            </section>
          </>
        )}
      </main>
    </div>
  );
}
